/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CertificateChainItem } from './CertificateChainItem';
import {
    CertificateChainItemFromJSON,
    CertificateChainItemFromJSONTyped,
    CertificateChainItemToJSON,
} from './CertificateChainItem';

/**
 * Related delegated signer credential
 * @export
 * @interface CredentialDetailedDto
 */
export interface CredentialDetailedDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    type?: CredentialDetailedDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    status?: CredentialDetailedDtoStatusEnum;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    issueeAlias?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    issuerAlias?: string;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    issuedAt?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof CredentialDetailedDto
     */
    revokedAt?: string;
    /**
     * 
     * @type {Array<CertificateChainItem>}
     * @memberof CredentialDetailedDto
     */
    certificateChain?: Array<CertificateChainItem>;
}


/**
 * @export
 */
export const CredentialDetailedDtoTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type CredentialDetailedDtoTypeEnum = typeof CredentialDetailedDtoTypeEnum[keyof typeof CredentialDetailedDtoTypeEnum];

/**
 * @export
 */
export const CredentialDetailedDtoStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type CredentialDetailedDtoStatusEnum = typeof CredentialDetailedDtoStatusEnum[keyof typeof CredentialDetailedDtoStatusEnum];


/**
 * Check if a given object implements the CredentialDetailedDto interface.
 */
export function instanceOfCredentialDetailedDto(value: object): boolean {
    return true;
}

export function CredentialDetailedDtoFromJSON(json: any): CredentialDetailedDto {
    return CredentialDetailedDtoFromJSONTyped(json, false);
}

export function CredentialDetailedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialDetailedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'certificateChain': json['certificateChain'] == null ? undefined : ((json['certificateChain'] as Array<any>).map(CertificateChainItemFromJSON)),
    };
}

export function CredentialDetailedDtoToJSON(value?: CredentialDetailedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'type': value['type'],
        'status': value['status'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'issuedAt': value['issuedAt'],
        'revokedAt': value['revokedAt'],
        'certificateChain': value['certificateChain'] == null ? undefined : ((value['certificateChain'] as Array<any>).map(CertificateChainItemToJSON)),
    };
}

